import * as React from 'react'
import Slider from 'react-slick'

type ArrowsProps = {
  sliderRef: React.RefObject<Slider>
}

export const Arrows: React.FC<ArrowsProps> = ({ sliderRef }) => {
  const handlePrevClick = () => {
    sliderRef.current?.slickPrev()
  }

  const handleNextClick = () => {
    sliderRef.current?.slickNext()
  }

  return (
    <div className="arrows-container">
      <div 
        className="custom-arrow btn-primary custom-arrow-prev"
        onClick={handlePrevClick}
        aria-label="Previous"
        as="button"
      >
        <i className="fa fa-chevron-left"></i>
      </div>
      <div 
        className="custom-arrow btn-primary custom-arrow-next"
        onClick={handleNextClick}
        aria-label="Next"
        as="button"
      >
        <i className="fa fa-chevron-right"></i>
      </div>
    </div>
  )
}